import React from 'react'

import { Box, CircularProgress } from '@forgeglobal/design-framework'

const Loading = () => (
  <Box display="flex" alignItems="center" justifyContent="center" height="100%">
    <CircularProgress color="secondary" />
  </Box>
)

export default Loading
